export default __webpack_public_path__ + "static/media/turtle.ed49fed0.png";